import { render } from "./view-invoice.vue?vue&type=template&id=4620b8bc&scoped=true"
import script from "./view-invoice.vue?vue&type=script&lang=js"
export * from "./view-invoice.vue?vue&type=script&lang=js"

import "./view-invoice.vue?vue&type=style&index=0&id=4620b8bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4620b8bc"]])

export default __exports__